import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';

import IsUnderGraduate from "@/pages/profile/sections/idVerification/sections/isUnderGraduate"
import QualificationNote from "@/pages/profile/sections/idVerification/sections/qualificationNote"
import LookingForNote from "@/pages/profile/sections/idVerification/sections/lookingForNote"
import UgDegreeList from "@/pages/profile/sections/idVerification/sections/ugDegreeList"
import MarksheetOrDegreeCert from "@/pages/profile/sections/idVerification/sections/marksheetOrDegreeCert"
import MarksheetDegreeCrop from "@/pages/profile/sections/idVerification/sections/marksheetDegreeCrop"
import FullName from "@/pages/profile/sections/idVerification/sections/fullName_"
import AadharOrIdProof from "@/pages/profile/sections/idVerification/sections/aadharOrIdProof"
import LegalPhoto from "@/pages/profile/sections/idVerification/sections/legalPhoto"
import AllInfoPage from "@/pages/profile/sections/idVerification/sections/allInfoPage"

import './style.css'

export default function IdVerificationStatusView(props: any) {
    const { profile } = useLocalTranslation();
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);

    const componentMap1: any = [
        <IsUnderGraduate
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.isUnderGraduate}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <UgDegreeList
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.underGraduateDegree}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <MarksheetOrDegreeCert
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.marksheetOrDegreeCert}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <MarksheetDegreeCrop
            handleInputChange={props.handleInputChange}
            value={props.marksheetOrDegreeCert}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmitV2}
        />,
        <FullName
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.fullName}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
            marksheetOrDegreeCertCrop={props.marksheetOrDegreeCertCrop}
        />,
        <AadharOrIdProof
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.aadharOrIdProof}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <LegalPhoto
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.legalPhoto}
            identityAcknowledged={props.identityAcknowledged}
            handleOnCheckBoxChanged={props.handleOnCheckBoxChanged}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <AllInfoPage
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />
    ];

    const componentMap2: any = [
        <IsUnderGraduate
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.isUnderGraduate}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <QualificationNote
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.qualificationNote}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <LookingForNote
            errMsg={props.errMsg}
            handleInputChange={props.handleInputChange}
            value={props.lookingForNote}
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />,
        <AllInfoPage
            isSubmitBtnLoading={props.isSubmitBtnLoading}
            handleSubmit={props.handleSubmit}
        />
    ];

    const ComponentToRender1 = componentMap1[props.profileStepNo];
    const ComponentToRender2 = componentMap2[props.profileStepNo];

    const setStyleForAllInfoPage = () => {
        let show = false
        if (profileDetails.isUnderGraduate != null) {
            if (profileDetails.isUnderGraduate === true && props.profileStepNo === 7) {
                show = true
            } else if (profileDetails.isUnderGraduate === false && props.profileStepNo === 3) {
                show = true
            }
        }
        return show
    }

    return (
        <div
            className={` idVerificationStatusViewMain
            rounded-[10px] profileSectionCommonMainCon`}>
            <h1
                style={{
                    marginBottom: "25px"
                }}
                className='commonH1'>{profile.identityVerificationSection.heading}</h1>

            {
                (profileDetails.isUnderGraduate != null && profileDetails.isUnderGraduate === true) ? (
                    <>
                        {ComponentToRender1 || null}
                    </>
                ) : (
                    <>
                        {ComponentToRender2 || null}
                    </>
                )
            }
        </div>
    );
}
